
export const messagesStore = (data, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/messages', data, {
			headers: { Authorization: 'Bearer ' + access_token }
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

export const messagesUpdate = (id, message, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post(`/api/messages/${id}`, {message: message}, {
			headers: { Authorization: 'Bearer ' + access_token }
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

export const messagesIndex = (search, page, access_token) => {
	return new Promise((resolve, reject) => {
		axios.get(`/api/messages`, {
			headers: { Authorization: 'Bearer ' + access_token },
			params: search ? {...search, page} : {page}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

export const messagesUnreadCount = (access_token) => {
	return new Promise((resolve, reject) => {
		axios.get(`/api/messages/unread-count`, {
			headers: { Authorization: 'Bearer ' + access_token }
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

export const messagesShow = (thread, access_token) => {
	return new Promise((resolve, reject) => {
		axios.get(`/api/messages/${thread}`, {
			headers: { Authorization: 'Bearer ' + access_token }
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

export const messagesThreadBy = (data, access_token) => {
	return new Promise((resolve, reject) => {
		axios.get(`/api/messages/thread-by`, {
			headers: { Authorization: 'Bearer ' + access_token },
			params: data
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

export const messageByPost = (post_id, access_token) => {
	return new Promise((resolve, reject) => {
		axios.get(`/api/messages/by/${post_id}`, {
			headers: { Authorization: 'Bearer ' + access_token }
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}
